export const iconMap = {
  all: 'feed',
  0: 'design',
  1: 'interface',
  2: 'desktop',
  3: 'emoji',
  4: 'illustration',
  7: '3d',
  9: 'ipad',
};

export const needXssKeys = [
  'res_name',
  'author_name',
  'res_desc',
  'res_label',
  'plugin_name',
  'plugin_cata',
  'plugin_desc',
  'plugin_html',
  'contact',
];

export function isMobile() {
  const ua = navigator.userAgent.toLowerCase();
  return /mobile|android|iphone|ipad|phone/i.test(ua);
}

export function isElectron(ua) {
  if (!ua || typeof ua !== 'string') {
    ua = process.client ? navigator.userAgent : "";
  }
  return /electron/i.test(ua.toLowerCase());
}

export function isTikTok() {
  const ua = navigator.userAgent.toLowerCase();
  return /BytedanceWebview|NewsArticle|TTWebView/i.test(ua);
}